export default "__VITE_ASSET__Dk38838p__"